<script setup lang="ts">
import { Event } from '@tix/entity'
import { isNotFoundError } from '@tix/openapi-sdk'

import { formatEventGalleryImages } from '@/helpers/imageHelpers'

import { errorTracker } from '@/services/errorTracking'

import { useGlobalError } from '@/stores/useGlobalErrorStore'

import DonationCompleteView, { type DonationCompleteViewProps } from '@/pages/DonationCompleteView.vue'

type DonationCompletePageProps = Omit<DonationCompleteViewProps, 'images' | 'frequency'>

const props = defineProps<DonationCompletePageProps>()

const eventTemplateId = props.id
const result = eventTemplateId ? await Event.load(eventTemplateId) : null

const event = result?.data ?? null
const eventTemplate = event?.data ?? null
const error = result?.error ?? null

const globalError = useGlobalError()

if (!eventTemplate) {
  if (isNotFoundError(error)) {
    globalError.set('Not found', { dismissable: false })
  } else {
    globalError.set('An unexpected error occurred', { dismissable: false })
    errorTracker.track(new Error('Error fetching donation event', { cause: error }), {
      operation: 'donation.complete.event.get',
      eventTemplateId,
    })
  }
}

const images = event ? formatEventGalleryImages(event.metadata) : []
</script>

<template>
  <DonationCompleteView
    v-if="eventTemplate"
    :id="id"
    :donationAmount="donationAmount"
    :images="images"
    :orderNumber="orderNumber"
    :receiptEmail="receiptEmail"
  />
</template>
